import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { formValueSelector } from 'redux-form';
import { anowVendorApiRequest } from '../../../shared/libs/anowApiRequest';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

const EstimatePrice = ({
  reportType,
  latitude,
  longitude,
  inspectionType,
  valueApproach,
}) => {
  const params = useParams();
  const [estimatedPrice, setPrice] = useState(null);
  useEffect(
    () => {
      if (reportType.id || inspectionType.id || valueApproach.id) {
        const typesQ = Object.entries({
          reportTypeId: reportType.id,
          inspectionTypeId: inspectionType.id,
          valueApproachId: valueApproach.id,
        })
          .filter(([, value]) => !!value)
          .map(([key, value]) => `${key}=${value}`)
          .join('&');
        const locationQ = latitude && longitude ? `&lat=${latitude}&lon=${longitude}` : '';
        anowVendorApiRequest({
          url: `/company/${params.companyName}/fee?${typesQ}${locationQ}`,
        })
          .then(({ data }) => data)
          .then(({ recommendedFee }) => {
            setPrice(recommendedFee);
          })
          .catch(() => {
            setPrice(null);
          });
      } else {
        setPrice(null);
      }
    },
    [reportType.id, inspectionType.id, valueApproach.id, latitude, longitude],
  );
  if (!estimatedPrice) {
    return null;
  }
  return (
    <div className="col-12">
      {`Estimated Final Price (you will not be charged yet): ${formatter.format(
        estimatedPrice,
      )}`}
    </div>
  );
};

EstimatePrice.propTypes = {
  reportType: PropTypes.shape({
    clientFee: PropTypes.number,
    id: PropTypes.number,
    name: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
  inspectionType: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }).isRequired,
  valueApproach: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }).isRequired,
  latitude: PropTypes.number,
  longitude: PropTypes.number,
};
EstimatePrice.defaultProps = {
  latitude: null,
  longitude: null,
};

const selector = formValueSelector('WizardOrderForm');

export default connect((state) => {
  const reportTypeName = selector(state, 'reportType.first');
  const inspectionTypeName = selector(state, 'inspectionType');
  const valueApproachName = selector(state, 'valueApproach');
  const latitude = selector(state, 'latitude');
  const longitude = selector(state, 'longitude');

  return {
    reportType:
      state.dropdownLists.reportType.find(
        ({ value }) => reportTypeName === value,
      ) || {},
    inspectionType:
      state.dropdownLists.inspectionTypes.find(
        ({ value }) => inspectionTypeName === value,
      ) || {},
    valueApproach:
      state.dropdownLists.valueApproaches.find(
        ({ value }) => valueApproachName === value,
      ) || {},
    latitude,
    longitude,
  };
})(EstimatePrice);
